import React from "react";
import { Container, Row, Col } from "react-bootstrap";
import TrackVisibility from "react-on-screen";

export const Experience = () => {
  const experiences = [
    {
      company: "Avlyon (Avida Platform)",
      role: "Software Engineer",
      duration: "Jan 2025 – Present",
      location: "Remote-USA",
      isCurrent: true,
      bullets: [
        "Building and maintaining Avida, a production platform, using React.js and Node.js on GCP and Firebase Cloud Functions",
        "Built Smart Check-In AI — achieved 60% adoption and 416+ AI suggestions in production",
        "Designed Metabase analytics dashboards for real-time user engagement monitoring",
        "Contributed to Smart Context and AI Coach Profile features",
      ],
    },
    {
      company: "CDAZZDEV",
      role: "Software Engineer",
      duration: "Jan 2024 – Dec 2024",
      location: "Remote-USA",
      bullets: [
        "Developed Unisyn, an AI-powered financial management platform using Next.js and Node.js",
        "Designed interactive dashboards and optimized UX with client collaboration",
      ],
    },
    {
      company: "Space IT Labs",
      role: "Trainee Software Engineer",
      duration: "Aug 2023 – Dec 2023",
      location: "Remote-UK",
      bullets: [
        "Supported development of Seamless Source using Vue.js and Laravel",
        "Enhanced frontend performance and backend stability",
      ],
    },
    {
      company: "VARStreet Inc.",
      role: "Junior Full-Stack Developer",
      duration: "Nov 2021 – Jul 2022",
      location: "Remote-USA",
      bullets: [
        "Built RStore, a React.js eCommerce tool",
        "Improved SQL data accuracy and reporting efficiency",
      ],
    },
  ];

  return (
    <section className="experience" id="experience">
      <Container>
        <Row>
          <Col xs={12}>
            <h2>Experience</h2>
            <div className="timeline-container">
              <div className="timeline-line"></div>
              {experiences.map((exp, index) => (
                <div className="timeline-item" key={index}>
                  <div className="timeline-dot"></div>
                  <TrackVisibility partialVisibility once>
                    {({ isVisible }) => (
                      <div
                        className={`experience-card ${
                          isVisible ? "visible-card" : "invisible-card"
                        }`}
                      >
                        <div className="card-header-row">
                          <h3 className="company-title">{exp.company}</h3>
                          <span className="job-duration">{exp.duration}</span>
                        </div>
                        <div className="badge-container">
                          <span className="role-badge">{exp.role}</span>
                          {exp.location && (
                            <span className="location-badge">
                              {exp.location}
                            </span>
                          )}
                          {exp.isCurrent && (
                            <span className="current-badge">
                              Currently Here
                            </span>
                          )}
                        </div>
                        <ul className="experience-bullets">
                          {exp.bullets.map((bullet, idx) => (
                            <li key={idx}>{bullet}</li>
                          ))}
                        </ul>
                      </div>
                    )}
                  </TrackVisibility>
                </div>
              ))}
            </div>
          </Col>
        </Row>
      </Container>
    </section>
  );
};
